function updateBlogReadMoreArrows(swiper) {
  const nav = swiper.el.querySelector('.swiper_navigation_block');
  if (!nav) return;

  const slideCount = swiper.slides.length;
  let perView = parseFloat(swiper.params.slidesPerView, 10);
  if (Number.isNaN(perView)) perView = 1;

  nav.classList.toggle('swiper_navigation_block--no-arrows', slideCount <= perView);
}

function initBlogReadMoreRoot(root) {
  const slider = root.querySelector('.blog-read-more__slider');
  if (!slider || !slider.id || typeof Swiper === 'undefined') return;
  if (slider.swiper) slider.swiper.destroy(true, true);

  new Swiper('#' + slider.id, {
    slidesPerView: 1.1,
    spaceBetween: 16,
    breakpoints: {
      641: { slidesPerView: 2, spaceBetween: 24 },
      991: { slidesPerView: 3, spaceBetween: 24 },
    },
    navigation: {
      nextEl: '#' + slider.id + ' .swiper-button-next',
      prevEl: '#' + slider.id + ' .swiper-button-prev',
    },
    pagination: {
      el: '#' + slider.id + ' .swiper-pagination',
      clickable: true,
    },
    on: {
      init() {
        updateBlogReadMoreArrows(this);
      },
      resize() {
        updateBlogReadMoreArrows(this);
      },
      breakpoint() {
        updateBlogReadMoreArrows(this);
      },
    },
  });
}

function initBlogReadMoreSliders(scope) {
  const container = scope || document;
  container.querySelectorAll('[data-blog-read-more]').forEach(initBlogReadMoreRoot);
}

function bootBlogReadMoreSliders() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initBlogReadMoreSliders());
  } else {
    initBlogReadMoreSliders();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initBlogReadMoreSliders(event.target);
  });
}

bootBlogReadMoreSliders();
